import { showForFPC } from '../../helpers/envServer';
import { ACTIVE_FEATURES } from '../featureFlag';
import gacChangeHistoryReportFieldMapping from '../fieldMappings/gacChangeHistoryReportFieldMapping';

export default {
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_NUMBER, secondary: '', type: 'string', link: false, label: showForFPC ? 'Doc Number' : 'Purchase Order Number', numeric: false, disablePadding: false, group: true, wrap: true, default: true, isCollapsible: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_NUMBER, secondary: '', type: 'string', link: false, label: showForFPC ? 'Line Item Number' : 'PO Line Item Number', numeric: false, disablePadding: false, group: true, wrap: true, default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OGAC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OGAC, secondary: '', type: 'date', link: false, label: 'OGAC', requestDataType: 'dynamicDate', numeric: false, disablePadding: false, group: true, wrap: true, default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC_REASON_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC_REASON_CODE, secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC_REASON_CODE_DESC, type: 'string', link: false, label: 'GAC Reason Code', numeric: false, disablePadding: false, group: true, wrap: true, default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GRC_USECASE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GRC_USECASE_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GRC_USECASE_CODE_DESC,
    type: 'string',
    link: false,
    label: 'GRC Usecase Code',
    numeric: false,
    disablePadding: false,
    group: true,
    wrap: true,
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_QUANTITY]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_QUANTITY, secondary: '', type: 'string', link: false, label: 'Quantity', numeric: false, disablePadding: false, group: true, wrap: true, default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NAF]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NAF, secondary: '', type: 'string', link: false, label: 'NAF%', numeric: false, disablePadding: false, group: true, wrap: true, default: true, width: '6%', includeInRequest: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FAF]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FAF, secondary: '', type: 'string', link: false, label: 'FAF%', numeric: false, disablePadding: false, group: true, wrap: true, default: true, width: '7%', includeInRequest: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_PONUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_PONUMBER,
    label: 'Trading Co Purchase Order Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VENDOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VENDOR,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VENDOR_NAME,
    label: 'Vendor',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VENDOR_NAME]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VENDOR_NAME,
    secondary: '',
    label: 'Vendor Name',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string'
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TIER2_VENDOR_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TIER2_VENDOR_CODE,
    secondary: '',
    label: 'Tier 2 Vendor Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string'
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIVISION_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIVISION_CODE,
    label: 'Division',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_NAME,
    label: 'Product',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_NAME]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_NAME,
    secondary: '',
    label: 'Product Name',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string'
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_QTY]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_QTY,
    label: 'Total Item Quantity',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true,
    width: '10%'
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_OPEN_QTY]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_OPEN_QTY,
    label: 'FPC Item Quantity',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true,
    width: '10%',
    featureFlag: ACTIVE_FEATURES.EMEA_FPC_UI
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SEASON_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SEASON_CODE,
    label: 'Season',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SEASON_YEAR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SEASON_YEAR,
    label: 'Season Year',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LAUNCH]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LAUNCH,
    label: 'Launch Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MIDSOLE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MIDSOLE_CODE,
    label: 'Midsole Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OUTSOLE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OUTSOLE_CODE,
    label: 'Outsole Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PROMO_ONLY_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PROMO_ONLY_INDICATOR,
    label: 'Promo Only Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ORDER_REASON_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ORDER_REASON_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ORDER_REASON_DESCRIPTION,
    label: 'Reason For Ordering',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_STYLE_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_STYLE_NUMBER,
    label: 'Style Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CURRENT_EVENT]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CURRENT_EVENT,
    label: 'Current Event',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NEXT_EVENT]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NEXT_EVENT,
    label: 'Next Event',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_PO]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_PO,
    label: 'Customer PO',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DOC_TYPE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DOC_TYPE_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DOC_TYPE_CODE_DESC,
    label: 'Doc Type',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_ORG_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_ORG_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_ORG_NAME,
    label: 'Purchase Org',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_GROUP_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_GROUP_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PURCHASE_GROUP_NAME,
    label: 'Purchase Group',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_COLOR_DESC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_COLOR_DESC,
    label: 'Color Description',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CREATED_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CREATED_DATE,
    label: 'Create Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DOC_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DOC_DATE,
    label: showForFPC ? 'Doc Date' : 'Document Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CHANGED_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CHANGED_DATE,
    label: 'Change Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC,
    label: 'Current GAC',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LAUNCH_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LAUNCH_DATE,
    label: 'Launch Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CURRENT_EVENT_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CURRENT_EVENT_DATE,
    label: 'Current Event Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NEXT_EVENT_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_NEXT_EVENT_DATE,
    label: 'Next Event Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ACCEPT_PO_ACTUAL_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ACCEPT_PO_ACTUAL_DATE,
    label: 'Acceptance Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FACTORY_DELIVERY_ACTUAL_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FACTORY_DELIVERY_ACTUAL_DATE,
    label: 'Factory Delivery Actual Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_EX_FACTORY_ACTUAL_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_EX_FACTORY_ACTUAL_DATE,
    label: 'Ex Factory Actual Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MRGAC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MRGAC,
    label: 'MRGAC',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    requestDataType: 'dynamicDate',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FX_ADJ_REQUIRED_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FX_ADJ_REQUIRED_INDICATOR,
    label: 'FX Adjustment Required Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANT_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANT_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANT_NAME,
    label: 'Plant',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FOB_MISMATCH_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FOB_MISMATCH_INDICATOR,
    label: 'Fob Mismatch Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SIZE_MISMATCH_ID]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SIZE_MISMATCH_ID,
    label: 'Size Mismatch Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_REQ_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_REQ_DATE,
    label: 'Customer Requested Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VAS_ITEM]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_VAS_ITEM,
    label: 'Item Vas',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_R3_DOC_TYPE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_R3_DOC_TYPE,
    label: 'Historical Doc Type',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CREATED_BY]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CREATED_BY,
    label: 'Created By',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TITLE_TRANSFER_MODEL_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TITLE_TRANSFER_MODEL_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TITLE_TRANSFER_MODEL_DESC,
    label: 'TTMI',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MFG_ORIGIN_COUNTRY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MFG_ORIGIN_COUNTRY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MFG_ORIGIN_COUNTRY_NAME,
    label: 'MCO',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_COMPANY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_COMPANY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_COMPANY_DESC,
    label: 'Company',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_COMPANY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_COMPANY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_COMPANY_DESC,
    label: 'Company Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_STATUS]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_STATUS,
    label: 'DPOM Line Item Status',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_UNIT_OF_MEASURE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_UNIT_OF_MEASURE_CODE,
    label: 'UoM',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DESTINATION_COUNTRY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DESTINATION_COUNTRY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DESTINATION_COUNTRY_NAME,
    label: 'Destination Country',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_PLANT_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_PLANT_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TR_CO_PLANT_NAME,
    label: 'Trading Company Plant',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TRANSPORT_MODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TRANSPORT_MODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TRANSPORT_MODE_DESC,
    label: 'Mode of Transportation',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SHIPPING_TYPE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SHIPPING_TYPE,
    label: 'Shipping Type',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIRECT_SALES_ORDER_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIRECT_SALES_ORDER_NUMBER,
    label: 'Direct Ship Sales Order Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIRECT_SALES_ORDER_ITEM_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIRECT_SALES_ORDER_ITEM_NUMBER,
    label: 'Direct Ship Sales Order Item Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DELIVERY_COMPLETE_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DELIVERY_COMPLETE_INDICATOR,
    label: 'Delivery Complete Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CANCEL_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CANCEL_DATE,
    label: 'Cancel Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'date',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUST_ISO_COUNTRY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUST_ISO_COUNTRY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_COUNTRY_NAME,
    label: 'Customer Country',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SALES_ORDER_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SALES_ORDER_NUMBER,
    label: 'Sales Order Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SALES_ORDER_ITEM_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SALES_ORDER_ITEM_NUMBER,
    label: 'Sales Order Item Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_TEXT_DETAIL]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_ITEM_TEXT_DETAIL,
    label: 'Item Text',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CATEGORY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CATEGORY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CATEGORY_DESC,
    label: 'Category',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SUB_CATEGORY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SUB_CATEGORY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SUB_CATEGORY_DESC,
    label: 'Sub Category',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_CATEGORY_FOCUS_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_CATEGORY_FOCUS_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_CATEGORY_FOCUS_DESC,
    label: 'Global Category Core Focus',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOABL_CATEGORY_SUMMARY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOABL_CATEGORY_SUMMARY_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOABL_CATEGORY_SUMMARY_DESC,
    label: 'Global Category Summary',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GENDER_AGE_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GENDER_AGE_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GENDER_AGE_DESC,
    label: 'Gender Age',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MARKETING_ID]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MARKETING_ID,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MARKETING_DESC,
    label: 'Marketing Type',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SILHOUTTE_TYPE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SILHOUTTE_TYPE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SILHOUTTE_TYPE_DESC,
    label: 'Silhouette',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIMENSION_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_DIMENSION_CODE,
    label: 'Dimension Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_REFILL_CLASS_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_REFILL_CLASS_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PRODUCT_REFILL_CLASS_DESC,
    label: 'Product Refill Class',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LEAGUE_ID_DESC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_LEAGUE_ID_DESC,
    label: 'League ID',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_REJECTION_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_REJECTION_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PO_REJECTION_CODE_DESC,
    label: 'DPOM Rejection Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OVERDUE_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OVERDUE_INDICATOR,
    label: 'Overdue Indicator',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_SHIP_TO]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_SHIP_TO,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_CUSTOMER_SHIP_TO_NAME,
    label: 'Ship To Customer',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: true
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_GROUP]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_GROUP,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_GROUP_DESC,
    label: 'Global Planning Product Group',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_CLASS]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_CLASS,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GLOBAL_PRODUCT_CLASS_DESC,
    label: 'Global Planning Product Classification',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANNING_PRIORITY_NUMBER]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANNING_PRIORITY_NUMBER,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PLANNING_PRIORITY_NUMBER_DESC,
    label: 'Planning Priority',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC_VS_MRGAC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GAC_VS_MRGAC,
    label: 'Gac Vs Mrgac',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OGAC_VS_MRGAC]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_OGAC_VS_MRGAC,
    label: 'Ogac Vs Mrgac',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MRGAC_CAPACITY_CONSUMPTION_WEEK]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_MRGAC_CAPACITY_CONSUMPTION_WEEK,
    label: 'MRGAC Capacity Consumption Week',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PMO_DEC_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PMO_DEC_CODE,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_PMO_DEC_CODE_DESC,
    label: 'PMO/DEC code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    type: 'string',
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GEOGRAPHY_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_GEOGRAPHY_CODE,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Geo Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TRCO_RELEVANT_INDICATOR]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_TRCO_RELEVANT_INDICATOR,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Trd Co rel',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_INITIAL_GAC_DATE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_INITIAL_GAC_DATE,
    secondary: '',
    type: 'date',
    link: false,
    label: 'Initial GAC Date',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    default: true,
    width: '10%'
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FIELDS_OF_PLAY_NAME]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FIELDS_OF_PLAY_ABBR,
    secondary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_FIELDS_OF_PLAY_NAME,
    type: 'string',
    link: false,
    label: 'Fields of Play',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    default: false
  },
  [gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SUB_TIER2_VENDOR_CODE]: {
    primary: gacChangeHistoryReportFieldMapping.GAC_CHANGE_HISTORY_SUB_TIER2_VENDOR_CODE,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Tier 2 Vendor Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false,
    group: true,
    default: false
  }
};
